/**
 * Thrown when the card form can't produce a payment method. The message is
 * fit to show to the user.
 */
export class PaymentMethodError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'PaymentMethodError'
  }
}
